class StickyHeaderControl extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = 0;
    this.ticking = false;
    this.windowWidth = window.innerWidth;
    this.handleScroll = this.handleScroll.bind(this);
    this.transparentIsActive = this.classList.contains('is-transparent');

    this.firstSection = document.querySelector("#page-homepage .shopify-section");
    this.intersectionObserver = null;
  }

  connectedCallback() {
    // Use passive listener for better performance
    document.body.style.setProperty('--sticky-offset', this.stickyOffset + 'px');

    if (this.isTabletOrSmaller) {
      document.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    // Set up intersection observer for transparent header background
    if (this.transparentIsActive && this.firstSection) {
      this.setupIntersectionObserver();
    }

    if (this.transparentIsActive) {
      this.addEventListener('mouseenter', () => {
        this.style.backgroundColor = 'var(--color-bg)';
      });

      this.addEventListener('mouseleave', () => {
        this.style.backgroundColor = 'transparent';
      });
    }

    // Add resize listener to update sticky offset
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.handleScroll);

    // Clean up intersection observer
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  handleScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.ticking = false;

        this.updateScrollDirection();

        if(this.lastDirection === 'up') {
          document.body.setAttribute('data-scroll-direction', 'up');

          if (window.scrollY <= this.stickyOffset) {
            this.classList.add('sticky-header-control--static');
            this.classList.remove('sticky-header-control--stuck');
            this.style.transition = 'transform 0s ease-in-out';
          } else {
            this.classList.remove('sticky-header-control--static');
            this.classList.remove('sticky-header-control--stuck');
            this.style.transition = 'transform 0.2s ease-in-out';
          }

          document.body.style.setProperty('--sticky-offset', this.stickyOffset + 'px');
        } else {
          document.body.setAttribute('data-scroll-direction', 'down');

          // When scrolling down, hide the header
          if (window.scrollY >= this.stickyOffset) {
            this.classList.remove('sticky-header-control--static');
            this.classList.add('sticky-header-control--stuck');
            document.body.style.setProperty('--sticky-offset', '0px');

            // Only disable transition when crossing the offset threshold
            if (this.lastScrollY < this.stickyOffset) {
              this.style.transition = 'transform 0s ease-in-out';
            } else {
              this.style.transition = 'transform 0.2s ease-in-out';
            }
          }
        }
      })
      this.ticking = true;
    }
  }

  updateScrollDirection() {
    const currentScrollY = window.scrollY;
    const direction = currentScrollY > this.lastScrollY ? 'down' : 'up';

    // Only update if direction actually changed
    if (direction !== this.lastDirection) {
      this.lastDirection = direction;
    }

    this.lastScrollY = currentScrollY;
  }

    setupIntersectionObserver() {
    try {
      // Create intersection observer to watch when first section is visible in viewport
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Check if the first section is visible in the viewport
            if (entry.isIntersecting) {
              this.style.backgroundColor = 'transparent';
            } else {
              this.style.backgroundColor = 'var(--color-bg)';
            }
          });
        },
        {
          // Use viewport as root (default)
          rootMargin: '0px',
          threshold: 0
        }
      );

      // Start observing the first section
      this.intersectionObserver.observe(this.firstSection);
    } catch (error) {
      console.warn('Failed to setup intersection observer:', error);
    }
  }

  get isTabletOrSmaller() {
    return window.innerWidth < 768;
  }

  get stickyOffset() {
    return this.offsetHeight;
  }

  handleResize () {
    if (window.innerWidth === this.windowWidth) return;

    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      document.body.style.setProperty('--sticky-offset', this.stickyOffset + 'px');
    }, 100);
  }
}

customElements.define('sticky-header-control', StickyHeaderControl);
